export enum CustomFields {
  FIRST_NAME = "firstName",
  LAST_NAME = "lastName",
  EVENT_NAME = "eventName",
  EVENT_DATE = "eventDate",
  VENUE_NAME = "venueName",
  VENUE_ADDRESS = "venueAddress",
}
